import { render, staticRenderFns } from "./CustomOverlay.vue?vue&type=template&id=d37fb3f2"
import script from "./CustomOverlay.vue?vue&type=script&lang=js"
export * from "./CustomOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports